var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.692 5.287c.372.373.64.836.778 1.345.793 3.19.61 8.23.016 11.544a3.02 3.02 0 0 1-2.124 2.124c-1.863.508-9.359.508-9.359.508s-7.496 0-9.358-.508A3.02 3.02 0 0 1 .52 18.176C-.277 15-.058 9.956.505 6.647A3.02 3.02 0 0 1 2.63 4.523C4.492 4.015 11.988 4 11.988 4s7.496 0 9.358.508c.509.138.973.406 1.346.779m-6.872 7.117-6.218 3.602V8.802z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;